import { ChatAdapter } from "./core/chat-adapter";
import { Observable, of } from "rxjs";
import { ChatP } from "../chat/chat.model";
import { AuthService } from "../../shared/services/auth.service";

export class DemoAdapter extends ChatAdapter {
    listFriends(): Observable<ChatP[]> {
        return of(AuthService.chats);
    }

    getMessageHistory(userId: any): Observable<ChatP[]> {
        let mockedHistory: Array<ChatP>;

        return of(mockedHistory);
    }
    
    sendMessage(message: ChatP): void {
       // setTimeout(() => {
            // let replyMessage = new ChatP();
            
            // replyMessage.fromId = message.toId;
            // replyMessage.toId = message.fromId;
            // replyMessage.message = "You have typed '" + message.message + "'";
            
            // let user = this.mockedUsers.find(x => x.id == replyMessage.fromId);

             this.onMessageReceived(message, message);
        //}, 1000);
    }
}